export const FORGE_CLEANING_TOOL_PATH = '/forge/labeling-tools/cleaning';
export const FORGE_DISTRACTORS_PATH = '/forge/labeling-tools/distractors';
export const FORGE_REMOTE_DC_TOOL_PATH = '/forge/labeling-tools/remote-dc';
export const FORGE_PR_REVIEW_PATH = '/forge/labeling-tools/pr-review';
export const FORGE_DESIGNS_DASHBOARD_PATH = '/forge/dashboards/designs';
export const FORGE_DESIGN_GROUPS_DASHBOARD_PATH = '/forge/dashboards/design-groups';
export const FORGE_LOCKED_DESIGNS_DASHBOARD_PATH = '/forge/dashboards/locked-designs';
export const FORGE_EXPORT_PATH = '/forge/dashboards/export';
export const FORGE_REVIEW_ISSUES_DASHBOARD_PATH = '/forge/task-lists/review-issues';
export const FORGE_VIZSIM_DATASETS_DASHBOARD_PATH = '/forge/dashboards/vizsim-datasets';
export const FORGE_PR_INFERENCE_OKRS_PATH = '/forge/dashboards/pr-inference-okrs';
export const FORGE_RECOGNITION_OKRS_PATH = '/forge/dashboards/recognition-okrs';
export const FORGE_RECOGNITION_REPLAY_PATH = '/forge/dashboards/recognition-replay';
export const FORGE_SYSTEM_HEALTH_PATH = '/forge/dashboards/system-health';
export const FORGE_REPORTED_ISSUES_PATH = '/forge/dashboards/reported-issues';
export const FORGE_COVERAGE_PATH = '/forge/dashboards/embedding-coverage';
export const FORGE_STORE_DC_TASK_LIST_PATH = '/forge/task-lists/store-dc';
export const FORGE_REMOTE_DC_TASK_LIST_PATH = '/forge/task-lists/remote-dc';
export const FORGE_UNRESOLVED_TASK_LIST_PATH = '/forge/task-lists/unresolved';
export const FORGE_CLEANING_TASK_LIST_PATH = '/forge/task-lists/cleaning';
export const FORGE_REMOTE_DC_CONFIG_PATH = '/forge/configuration/remote-dc';
export const FORGE_RECOGNITION_THRESHOLDS_CONFIG_PATH =
  '/forge/configuration/recognition-thresholds';
